var _defs, _clipPath, _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveymonkey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2500,
    height: 2500,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 44.345,
    cy: 44.607,
    r: 44.441
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M-.048.166h88.88v88.88H-.047z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#d)",
    fill: "#DDDDDC",
    d: "M44.393 89.048c24.544 0 44.44-19.897 44.44-44.44 0-24.544-19.896-44.44-44.44-44.44S-.047 20.063-.047 44.607c0 24.542 19.896 44.44 44.44 44.44"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "#BDCF31",
    d: "M-70.277-48.617H159.37V123.62H-70.276z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    d: "M0 44.607c0 24.543 19.897 44.44 44.44 44.44 24.544 0 44.44-19.897 44.44-44.44 0-24.545-19.896-44.44-44.44-44.44C19.897.166 0 20.062 0 44.606",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "#fff",
    d: "M72.058 40.107c-.704 0-1.4.097-2.056.256-2.59-10.254-11.162-18.114-21.78-19.685-.16-1.79.525-4.597 5.002-7.302l-.134-.263s-7.498 2.372-9.193 7.054c.074-1.462-.458-3.658-3.714-5.22 0 0-.257.088-.127.206.646.597 2.703 2.587 1.83 5.358-11.29 1.027-20.53 9.14-23.238 19.854a8.659 8.659 0 0 0-2.056-.256c-4.738 0-8.595 3.848-8.595 8.6 0 4.743 3.858 8.597 8.595 8.597 1.11 0 2.168-.22 3.14-.602a26.244 26.244 0 0 0 2.793 5.196l7.166-4.832-.092-.058c-1.887-2.425-3.04-5.996-3.234-9.55-.214-3.92.742-7.813 3.245-10.102 5.16-4.393 10.778-2.39 14.3 1.82h.94c3.522-4.127 9.077-6.045 14.196-1.7 2.47 2.274 3.436 6.1 3.248 9.968-.17 3.588-1.33 7.216-3.225 9.658l7.064 4.795a26.632 26.632 0 0 0 2.786-5.197c.972.38 2.028.602 3.137.602 4.75 0 8.597-3.855 8.597-8.6a8.594 8.594 0 0 0-8.596-8.598m-55.172 10.32c-.946 0-1.72-.767-1.72-1.724a1.724 1.724 0 0 1 2.697-1.428c.01.913.08 1.812.185 2.7a1.718 1.718 0 0 1-1.162.452m54.875.004a1.73 1.73 0 0 1-1.15-.44c.103-.894.173-1.797.184-2.714.277-.186.61-.298.968-.298.95 0 1.726.775 1.726 1.73 0 .958-.78 1.723-1.727 1.723"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveymonkey);
export default __webpack_public_path__ + "static/media/surveymonkey.6c66aab2cb207c574b42e7e63ba1e68a.svg";
export { ForwardRef as ReactComponent };